import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBMcTJht69ZulnZjnvbXDyiZEHYg-WeXyM",
  authDomain: "autenticacao-482007.firebaseapp.com",
  projectId: "autenticacao-482007"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Funcao para login com Google
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    const token = await user.getIdToken();

    return {
      success: true,
      token: token,
      user: {
        email: user.email,
        nome: user.displayName,
        foto: user.photoURL
      }
    };
  } catch (error) {
    console.error('Erro no login Google:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Funcao para logout
export const signOutGoogle = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    console.error('Erro no logout:', error);
    return { success: false, error: error.message };
  }
};

export { auth };
